import { SIGNIN_PAGES_ROUTES } from "constants/routes";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { clearCookiesLogout } from "../../persistence/access";
import type { NavigationDropdownProps } from "./NavigationDropdown.model";
import { StyleContent, StyleRow, StyledMenu } from "./NavigationDropdown.styled";

export const NavigationDropdown: React.FC<NavigationDropdownProps> = ({ dataCy, userInfo }) => {
  const { t } = useTranslation("header");
  const history = useHistory();

  const onLogout = () => {
    clearCookiesLogout();
    history.push(SIGNIN_PAGES_ROUTES.SIGNIN_PAGE);
  };

  return (
    <StyledMenu data-cy={dataCy} user={userInfo}>
      <StyleContent>
        <StyleRow>
          <a href="https://www.noordhoff.nl/noordhoff/voorwaarden" rel="noreferrer" target="_blank">
            {t("navigationMenu.termsConditions")}
          </a>
        </StyleRow>
        <StyleRow>
          <a href="https://www.noordhoff.nl/privacy" rel="noreferrer" target="_blank">
            {t("navigationMenu.privacyStatement")}
          </a>
        </StyleRow>
        <StyleRow>
          <a href="https://studiemeister.zendesk.com/hc/nl" rel="noreferrer" target="_blank">
            {t("navigationMenu.helpDocument")}
          </a>
        </StyleRow>
        <StyleRow>
          <div data-cy="logout-button" role="button" tabIndex={0} onMouseDown={onLogout}>
            {t("navigationMenu.logout")}
          </div>
        </StyleRow>
      </StyleContent>
    </StyledMenu>
  );
};
